<script setup lang="ts">
import type { Image } from "~/types/common";

export interface CategoryCardProps {
  slug?: string;
  title?: string;
  image?: Image;
}

const props = defineProps<CategoryCardProps>();
</script>

<template>
  <NuxtLinkLocale
    :to="`/education/${props.slug}`"
    class="d-flex flex-column edu-category-card p-10 br-20 text-decoration-none"
  >
    <img
      :src="$getStrapiImageSrc(props.image)"
      class="img-fluid br-20 object-fit-cover"
      style="height: 200px"
    />

    <h5 class="mt-20 mb-0">{{ props.title }}</h5>
  </NuxtLinkLocale>
</template>
